import { PUBLIC_SERVICE_BASE_URL } from 'config/constants';
import { ScopedURLBuilder } from 'utils/linkUtils';

const builder = new ScopedURLBuilder(PUBLIC_SERVICE_BASE_URL);

export const asset = {
  download: builder.createAPICall('rsp/discover/asset/:assetId?buildType=:buildType'),
};
